var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPrizeDrawWin40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrizeDrawWin40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "PrizeDrawWin48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.379421, 5.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(3.287245, 8.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 L14.1666667,0 L14.1666667,8.33333333 C14.1666667,11.5549944 11.5549944,14.1666667 8.33333333,14.1666667 C5.11167229,14.1666667 2.5,11.5549944 2.5,8.33333333 L2.5,0 L2.5,0 Z",
    id: "Rectangle",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.833333333,3.33333333 L3.33333333,3.33333333 L3.33333333,3.75 C3.33333333,4.90059323 2.40059323,5.83333333 1.25,5.83333333 C0.0994067712,5.83333333 -0.833333333,4.90059323 -0.833333333,3.75 L-0.833333333,3.33333333 L-0.833333333,3.33333333 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(1.250000, 4.583333) rotate(90.000000) translate(-1.250000, -4.583333) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,3.33333333 L17.5,3.33333333 L17.5,3.75 C17.5,4.90059323 16.5672599,5.83333333 15.4166667,5.83333333 C14.2660734,5.83333333 13.3333333,4.90059323 13.3333333,3.75 L13.3333333,3.33333333 L13.3333333,3.33333333 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.416667, 4.583333) scale(-1, 1) rotate(90.000000) translate(-15.416667, -4.583333) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 14.1666667,
    x2: 8.75,
    y2: 19.1666667,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 18.75,
    x2: 12.5,
    y2: 18.75,
    id: "Path-8"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 2.9051447,
    y1: 7.70049563,
    x2: 0.415020672,
    y2: 6.87045429,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.826137,
    y1: 7.70049563,
    x2: 20.3360129,
    y2: 6.87045429,
    id: "Line-3",
    transform: "translate(21.581075, 7.285475) scale(-1, 1) translate(-21.581075, -7.285475) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.953912, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 4.58333333,
    x2: 0.416666667,
    y2: 2.08333333,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9166667,
    y1: 4.58333333,
    x2: 12.0833333,
    y2: 2.08333333,
    id: "Line-3",
    transform: "translate(12.500000, 3.333333) scale(-1, 1) translate(-12.500000, -3.333333) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.08333333,
    y1: 3.33333333,
    x2: 7.08333333,
    y2: 0,
    id: "Line"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPrizeDrawWin40);
export default __webpack_public_path__ + "static/media/pictogramBeaconPrizeDrawWin40.5ec35e7e36d601211994808dc2de184c.svg";
export { ForwardRef as ReactComponent };